import createEntry from 'common/core/createEntry';

import JobsApp from './JobsApp';
import JobsReducers from './JobsReducers';

const GA4MeasurementID = 'G-ZRZX1J1VT8';
const SentryDSN = 'daec8fa2fdc745a788006f75eeadb7b4';

createEntry({
  app: JobsApp,
  ga4MeasurementID: GA4MeasurementID,
  reducers: JobsReducers,
  sentryDSN: SentryDSN,
});
